import './form-control.css';
export default {
  "formControl": "pf-v5-c-form-control",
  "formControlIcon": "pf-v5-c-form-control__icon",
  "formControlToggleIcon": "pf-v5-c-form-control__toggle-icon",
  "formControlUtilities": "pf-v5-c-form-control__utilities",
  "modifiers": {
    "readonly": "pf-m-readonly",
    "success": "pf-m-success",
    "warning": "pf-m-warning",
    "error": "pf-m-error",
    "plain": "pf-m-plain",
    "expanded": "pf-m-expanded",
    "disabled": "pf-m-disabled",
    "icon": "pf-m-icon",
    "placeholder": "pf-m-placeholder",
    "resizeVertical": "pf-m-resize-vertical",
    "resizeHorizontal": "pf-m-resize-horizontal",
    "resizeBoth": "pf-m-resize-both",
    "status": "pf-m-status"
  },
  "themeDark": "pf-v5-theme-dark"
};